import { TypedDocumentNode, gql } from '@apollo/client';
import { useMemo } from 'react';
import styled from 'styled-components';

import { FullWidth } from '@sorare/core/src/atoms/layout/Container';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';

import { PromotionalEvent } from './PromotionalEvent';
import { PromotionalEvents_PromotionalEvent } from './__generated__/index.graphql';

const GAP = 2;
const Wrapper = styled(Horizontal).attrs({ gap: GAP })`
  flex-wrap: wrap;
  padding-top: var(--double-unit);
`;

type Props = {
  promotionalEvents: PromotionalEvents_PromotionalEvent[];
};

export const PromotionalEvents = ({ promotionalEvents }: Props) => {
  const promotionalEventsWithBanner = useMemo(
    () => promotionalEvents.filter(p => p.pictureUrl),
    [promotionalEvents]
  );
  if (promotionalEventsWithBanner.length === 0) {
    return null;
  }

  return (
    <FullWidth>
      <Wrapper>
        {promotionalEventsWithBanner.map(p => (
          <PromotionalEvent key={p.slug} promotionalEvent={p} />
        ))}
      </Wrapper>
    </FullWidth>
  );
};

PromotionalEvents.fragments = {
  PromotionalEvent: gql`
    fragment PromotionalEvents_PromotionalEvent on PromotionalEventInterface {
      slug
      ...PromotionalEvent_PromotionalEvent
    }
    ${PromotionalEvent.fragments.PromotionalEvent}
  ` as TypedDocumentNode<PromotionalEvents_PromotionalEvent>,
};
